import React, { useEffect } from 'react';
import { Image, TouchableOpacity } from 'react-native';

import { Box, ShadowBox, Text } from '@components/Restyle';
import Icon from '@components/shared/Icon/Icon';
import {
  ChatDrawerScreen,
  useWebDrawer,
} from '@components/Web/Drawer/WebDrawerContext';
import { useCreateChatMutation } from '@graphql/generated';
import useActiveChat from '@hooks/useActiveChat';
import { useAppNavigation } from '@navigation/useAppNavigation';

const HelpStack: React.FC = () => {
  const supportUserId = `${process.env.SUPPORT_USER_ID}`;
  const { setIsOpenChat } = useActiveChat();
  const navigation = useAppNavigation();
  const { chatExpanded, chatListOpen, setChatListOpen, setShouldChatListOpen } =
    useWebDrawer();

  const [createChat, { data: createChatData }] = useCreateChatMutation();

  useEffect(() => {
    if (!createChatData) return;
    const { createChat: createdChat } = createChatData;
    if (!chatExpanded && chatListOpen) {
      setShouldChatListOpen(true);
      setChatListOpen(false);
    }
    setIsOpenChat(true);
    navigation.navigateToChatDrawer({
      screen: ChatDrawerScreen.details,
      activeChat: createdChat,
    });
  }, [createChatData]);

  const openChat = () => {
    if (!supportUserId) {
      return;
    }

    createChat({
      variables: {
        attributes: {
          userIds: [supportUserId],
        },
      },
    });
  };

  return (
    <Box marginLeft='m'>
      <Box flexDirection='row' alignContent='flex-start'>
        <Image
          source={require('../../assets/images/help.png')}
          style={{
            width: 344,
            height: 351,
          }}
        />
        <Box alignContent='center' alignSelf='center'>
          <Text variant='heading1' verticalAlign='middle'>
            {' '}
            We are here to help{' '}
          </Text>
        </Box>
      </Box>
      <Box flexDirection='row' marginTop='l' marginRight='l' flex={1}>
        <ShadowBox borderRadius='m' margin='s' flex={1}>
          <TouchableOpacity onPress={openChat}>
            <Box margin='l'>
              <Box flexDirection='row' marginBottom='m'>
                <Icon
                  name='MessageSquare'
                  variant='m'
                  color='white'
                  backgroundColor='black'
                />
              </Box>
              <Text variant='bodySecondaryBold'>Chat With Us (Live!)</Text>
              <Text variant='bodySecondary' marginTop='xs'>
                Send us your questions or feedback—our team is here to help.
              </Text>
            </Box>
          </TouchableOpacity>
        </ShadowBox>
        <ShadowBox borderRadius='m' margin='s' flex={1}>
          <TouchableOpacity
            onPress={() => {
              window.open(
                'https://portal.tasktag.com/product',
                '_blank',
                'noopener'
              );
            }}>
            <Box margin='l'>
              <Box flexDirection='row' marginBottom='m'>
                <Icon
                  name='HelpCircle'
                  variant='m'
                  color='white'
                  backgroundColor='black'
                />
              </Box>
              <Text variant='bodySecondaryBold'>FAQ</Text>
              <Text variant='bodySecondary' marginTop='xs'>
                Check out our FAQ page for quick answers to common questions.
              </Text>
            </Box>
          </TouchableOpacity>
        </ShadowBox>
        <ShadowBox borderRadius='m' margin='s' flex={1}>
          <TouchableOpacity
            onPress={() => {
              window.open(
                'https://portal.tasktag.com/demo',
                '_blank',
                'noopener'
              );
            }}>
            <Box margin='l'>
              <Box flexDirection='row' marginBottom='m'>
                <Icon
                  name='Users'
                  variant='m'
                  color='white'
                  backgroundColor='black'
                />
              </Box>
              <Text variant='bodySecondaryBold'>Book a Demo</Text>
              <Text variant='bodySecondary' marginTop='xs'>
                Schedule a personalized demo to explore how it works.
              </Text>
            </Box>
          </TouchableOpacity>
        </ShadowBox>
      </Box>
    </Box>
  );
};

export default HelpStack;
